import moment from "moment/moment";
import { dayIndices, months } from "../constant"
import { formatTime } from "../AddDoctor/timeRanges";
export const getProviderArray = () => {
  const userDetails = getUserDetails()
  let providerArray = [];
  if (userDetails?.parentProvider?.isParent) {
    let childProviders = userDetails.parentProvider.childEntities
    const childProvidersArray = Object.keys(childProviders);
    providerArray = [...childProvidersArray];
  }
  else {
    providerArray = [userDetails?.providerId];
  }
  providerArray = providerArray.map(id => parseInt(id, 10));
  return providerArray
}


export const getProviderList = () => {
  const userDetails = getUserDetails()
  let providerArray = [];
  if (userDetails?.parentProvider?.isParent) {
    let childProviders = userDetails.parentProvider.childEntities
    const locationsArray = Object.values(childProviders).map(location => location.split(",")[0].trim());
    providerArray = [...locationsArray];
  }
  else {
    providerArray = [userDetails?.entityName];
  }
  return providerArray
}

export function getTimeFromMinutes(minutes) {
  const duration = moment.duration(minutes, 'minutes');
  const formattedTime = `${Math.floor(duration.asHours())}:${duration.minutes()}`;

  return formattedTime;
}

export const getFormatedTimeString = (timeString) => {
  const timeInHours = getTimeFromMinutes(timeString);
  const formattedTime = formatTime(timeInHours);
  return formattedTime
}


export const getProviderNameMapping = () => {
  const userDetails = getUserDetails()
  const mapping = {};

  if (userDetails.parentProvider.isParent) {
    let childProviders = userDetails.parentProvider.childEntities
    for (const [id, fullName] of Object.entries(childProviders)) {
      const locationName = fullName.split(",")[0].trim();
      mapping[locationName] = id;
    }
  }
  else {
    mapping[userDetails.entityName] = userDetails.providerId;
  }
  return mapping
}


export const getProviderIdMapping = () => {
  const userDetails = getUserDetails()
  const mapping = {};

  if (userDetails.parentProvider.isParent) {
    let childProviders = userDetails.parentProvider.childEntities
    for (const [id, fullName] of Object.entries(childProviders)) {
      const providerName = fullName.split(",")[0].trim();
      mapping[id] = providerName;
    }
  }
  else {
    mapping[userDetails.providerId] = userDetails.entityName;
  }
  return mapping
}

export const getUserDetails = () => {
  let userDetails = (localStorage.getItem('user_details'));
  userDetails = typeof userDetails != 'string' ? userDetails : JSON.parse(userDetails);
  return userDetails
}


export const transformDoctorSlots = (doctorSlotsNew) => {
  const groupedSlots = doctorSlotsNew?.reduce((acc, slot) => {
    const day = slot.dayOfWeek;
    if (!acc[day]) {
      acc[day] = [];
    }
    acc[day].push(slot);
    return acc;
  }, {});

  const doctorSlots = {
    DoctorSlots: {}
  };
  for (const day in groupedSlots) {
    groupedSlots[day].sort((a, b) => a.startTime - b.startTime);
  }


  if (!groupedSlots) {
    return
  }
  for (const day of dayIndices) {
    const dayName = day;
    const slots = groupedSlots[day];
    if (slots) {
      doctorSlots.DoctorSlots[dayName] = {
        isSlotsAvailable: slots.length > 0,
      };

      slots.forEach((slot, index) => {
        const durationKey = `duration${index + 1}`;
        doctorSlots.DoctorSlots[dayName][durationKey] = {
          totalSlots: slot.totalSlots,
          startTime: getTimeFromMinutes(slot.startTime),
          endTime: getTimeFromMinutes(slot.endTime),
          split: slot.split
        };
      });

      for (let i = slots.length; i < 3; i++) {
        const durationKey = `duration${i + 1}`;
        doctorSlots.DoctorSlots[dayName][durationKey] = {
          totalSlots: 0,
          startTime: null,
          endTime: null
        };
        break;
      }
    }
    else {
      doctorSlots.DoctorSlots[dayName] = {
        isSlotsAvailable: false,
        duration1: { totalSlots: 0, startTime: null, endTime: null },
      }
    }
  }
  return doctorSlots
}

export const groupHolidaysByMonth = (holidayList) => {
  if (!holidayList?.length) {
    return;
  }
  const holidays = holidayList.filter((holiday) => holiday.isActive != false);
  holidays.sort((a, b) => new Date(a.date) - new Date(b.date));
  const groupedHolidays = {};
  let range = [];
  for (let i = 0; i < holidays.length; i++) {
    const date = moment(holidays[i].date);
    const month = months[date.month()];
    if (!groupedHolidays[month]) {
      groupedHolidays[month] = [];
    }
    let curr = moment(holidays[i].date);
    let next = i < holidays.length - 1 ? moment(holidays[i + 1].date) : null;
    if (i < holidays.length - 1 && next.diff(curr, "days") <= 1 && next.month() == curr.month()) {
      range.push(holidays[i]);
    } else {
      if (range.length > 0) {
        range.push(holidays[i]);
        groupedHolidays[month].push(range);
        range = [];
      } else {
        groupedHolidays[month].push([holidays[i]]);
      }
    }
  }
  return groupedHolidays;
}

export const validateFileSizeLimit = (file, noMBs) => {
  const maxSizeInBytes = 1024 * 1024 * noMBs;
  if (file.size > maxSizeInBytes) {
    return false;
  }
  return true;
};


export const getUrlForDoctorProfilePage = (drId) => {
  return `/offlineConsults/DoctorManagements?drId=${drId}`;
}

export const getUrlForDoctorHolidaysPage = (drId) => {
  return `/offlineConsults/DoctorManagements/Holidays?drId=${drId}`;
}


export const getUrlForDoctorSchedulePage = (drId) => {
  return `/offlineConsults/DoctorManagements/Schedule?drId=${drId}`;
}

export const isValidDoctorSlotsAddition = (doctorSlots, day) => {

  const currentDaySlots = doctorSlots.filter((slot) => slot.dayOfWeek == day);
  const sortedCurrentDaySlots = currentDaySlots.sort((a, b) => a.startTime - b.startTime);
  if (currentDaySlots.length > 1) {
      for (let i = 1; i < currentDaySlots.length; i++) {
          const currentSlot = sortedCurrentDaySlots[i];
          const previousSlot = sortedCurrentDaySlots[i - 1];
          if (currentSlot.startTime < previousSlot.endTime) {
              return false;
          }
      }
  }
  return true;
}

export const getSpecialityList = (OFCSpeciality) => {
  const sortedLabels = (OFCSpeciality ?? [])
      .sort((a, b) => a.label.localeCompare(b.label))
      .map(item => item.label);
    return sortedLabels;

}